export default __webpack_public_path__ + "80c65054381a5a2fc3e00e6502b3b6f5.png";